import styles from "../Select.module.css";

function getMembershipLabelParts(displayName: string | null) {
  if (!displayName) {
    return { primaryText: "", secondaryText: null };
  }

  const openedIndex = displayName.indexOf(" Opened ");

  if (openedIndex === -1) {
    return { primaryText: displayName, secondaryText: null };
  }

  return {
    primaryText: displayName.slice(0, openedIndex),
    secondaryText: displayName.slice(openedIndex + 1),
  };
}

function MembershipLabel({ displayName }: { displayName: string | null }) {
  const { primaryText, secondaryText } = getMembershipLabelParts(displayName);

  return (
    <span className={`${styles.membershipLabelContent} sentry-mask`}>
      <span className={`${styles.membershipPrimaryText} sentry-mask`}>{primaryText}</span>
      {secondaryText ? (
        <span className={`${styles.membershipSecondaryText} sentry-mask`}>{secondaryText}</span>
      ) : null}
    </span>
  );
}

export { MembershipLabel };
